import { AccredibleObjectWithId } from '@accredible-frontend-v2/models';
import { AccredibleButtonComponentModule } from '@accredible-frontend-v2/new-components/button';
import { AccredibleIconComponentModule } from '@accredible-frontend-v2/new-components/icon';
import { AccredibleMultiSearchFilterModule } from '@accredible-frontend-v2/new-components/multi-search-filter';
import { SidenavRef } from '@accredible-frontend-v2/services/sidenav';
import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { SkillCategoriesService } from '../services/skill-categories.service';

@Component({
  standalone: true,
  templateUrl: `./skill-categories-mobile-filter.component.html`,
  styleUrls: ['./skill-categories-mobile-filter.component.scss'],
  imports: [
    TranslocoModule,
    AccredibleIconComponentModule,
    AccredibleButtonComponentModule,
    AccredibleMultiSearchFilterModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkillCategoriesMobileFilterComponent {
  private readonly _sidenavRef = inject(SidenavRef);

  readonly _skillCategories = inject(SkillCategoriesService);

  selectedOptions = signal<AccredibleObjectWithId[]>(
    this._skillCategories.selectedSkillCategories(),
  );

  hasChanges = computed(() => {
    const original = this._skillCategories.selectedSkillCategories();
    const local = this.selectedOptions();

    return (
      original.length !== local.length ||
      !original.every((originalCategory) =>
        local.some((localCategory) => localCategory.id === originalCategory.id),
      )
    );
  });

  closeFilters(): void {
    this._sidenavRef.close();
  }

  applyFilters(): void {
    this._sidenavRef.close({
      selectedSkillCategories: this.selectedOptions(),
    });
  }

  queryChange(query: string): void {
    this._skillCategories.filterBy(query);
  }

  selectedSkillCategoriesChange(newSelection: AccredibleObjectWithId[]): void {
    this.selectedOptions.set(newSelection);
  }
}
